import PageWrapper from "components/PageWrapper";
import PermissionsTable from "./user-permission-table";

function UserPermissions() {
  return (
    <PageWrapper>
      <PermissionsTable />
    </PageWrapper>
  );
}

export default UserPermissions;
